import { configureStore } from '@reduxjs/toolkit';
//import { setStore } from './storeProxy';
import rootReducer from './reducers';
import { persistStore } from 'redux-persist';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }),
});

// Initializes store within core library for request interceptors and messaging
//setStore(store);

export const persistor = persistStore(store);

export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
const useSelectorClone: TypedUseSelectorHook<RootState> = useSelector;
export const useAppSelector = () => useSelectorClone((s) => s);
export const useAppDispatch = () => useDispatch<AppDispatch>();
